export default {
  DotcomMobileFooter__COPYRIGHT: (data) =>
    `© ${data.year} Southwest Airlines Co. All Rights Reserved.`,
};
